import calcProfitAm from "./calcProfit";

// function to format systems
export const formatSystem = (system) => {
    let units = 1;
    let w = 0, l = 0, p = 0, prof = 0, roiData = [];
    // loop over each season in matches to get w,l,p, profit, and roi data for each system
    let seasons = Object.keys(system.matches);
    for(const szn of seasons){
        if(system.matches[szn].length > 0){
            for(const game of system.matches[szn]){
                let betProf;
                if(game.bet.result === "W"){
                    w = w+1;
                    betProf = calcProfitAm(game.bet.odds, units);
                    prof = prof + betProf;
                }else if(game.bet.result === "L"){
                    l = l+1;
                    prof = prof - units;
                }else if(game.bet.result === "P"){
                    p = p+1;
                };
                roiData.push((prof/((w+l)*units))*100)
            };
        }
    }
    // calculate ROI
    let roi = (prof/((w+l)*units))*100
    return({...system, w: w, l:l, p:p, profit:prof.toFixed(2), roi:roi.toFixed(2), roiData:roiData});
};

// Format bet name to be more readable
export const formatBetName = (bet) => {
    if (bet === 'over' || bet === 'under') {
        return bet.charAt(0).toUpperCase() + bet.slice(1);
    }
        
    const [team, type] = bet.split('.');
    if (type === 'ml') {
        return `${team.charAt(0).toUpperCase() + team.slice(1)} Moneyline`;
    } else if (type === 'runline') {
        return `${team.charAt(0).toUpperCase() + team.slice(1)} Runline`;
    } else if (type === 'spread') {
        return `${team.charAt(0).toUpperCase() + team.slice(1)} Spread`;
    }
    return bet;
};  